<template>
  <p class="a-input a-input--disabled ">
    {{$t('form.notifications.complaint-received', {person, email})}}
  </p>
</template>

<script>
  import MessageTheme from '@/api/types/message-theme'

  export default {
    props: {
      data: Object,
      required: true
    },

    computed: {
      person() {
        return this.data.fio;
      },

      email() {
        return this.data.email;
      }
    },

    methods: {
      async onClick() {
        this.$router.push({
          name: 'messages-inbox-filtered',
          params: {
            kind: 'complaint'
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
